import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyVerificateSource = lazy(() => import('./VerificateSource'));

export const VerificateSource: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyVerificateSource {...props} />
	</Suspense>
);
